type OnboardingFooterProps = {
  children: React.ReactNode;
  leftContent?: React.ReactNode;
};

export default function OnboardingFooter({
  children,
  leftContent,
}: OnboardingFooterProps) {
  return (
    <div className="sticky bottom-0 z-20 bg-gradient-to-t from-background via-background to-transparent pt-6 pb-4 -mx-4 px-4 md:mx-0 md:px-0">
      <div className="flex items-center justify-between gap-4 bg-white border border-ds-border-200 rounded-xl p-4 shadow-lg">
        {leftContent && (
          <div className="text-sm text-ds-text-500 hidden md:block">
            {leftContent}
          </div>
        )}
        <div className="ml-auto flex items-center gap-3">{children}</div>
      </div>
    </div>
  );
}
